import React from 'react'
import { StyleSheet, Text as NativeText, ViewStyle } from 'react-native'
// import styles from './index.scss'

interface Props {
    style?: ViewStyle|Array<ViewStyle>;
}

const Text: React.FC<Props> = (props) => {

    const { style } = props;

    return (
        <NativeText {...props} style={[styles.text, style]}>
            {props.children}
        </NativeText>
    );

};

const styles = StyleSheet.create({
    text: {}
});

export {
    Text
}